import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";
var _excluded = ["inline", "node", "components", "data"],
  _excluded2 = ["data-meta"];
var _templateObject;
import CodeLayout from 'react-code-preview-layout';
import { getMetaId, isMeta, getURLParameters } from 'markdown-react-code-preview-loader';
import MarkdownPreview from '@uiw/react-markdown-preview';
import styled from 'styled-components';
import rehypeIgnore from 'rehype-ignore';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Preview = CodeLayout.Preview;
var Code = CodeLayout.Code;
var Toolbar = CodeLayout.Toolbar;
var MarkdownStyle = styled(MarkdownPreview)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  margin: 0 auto;\n  box-shadow: rgb(8 15 41 / 8%) 0.5rem 0.5rem 2rem 0px, rgb(8 15 41 / 8%) 0px 0px 1px 0px;\n  border: 1px solid var(--color-border-default, #30363d);\n  text-align: left;\n  max-width: 56rem;\n  overflow: auto;\n  padding: 3rem 3rem;\n  border-radius: 5px;\n"])));
var CodePreview = _ref => {
  var _node$position;
  var {
      inline,
      node,
      components,
      data
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _ref2 = props,
    {
      'data-meta': meta
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  if (inline || !isMeta(meta)) {
    return /*#__PURE__*/_jsx("code", _extends({}, props));
  }
  var line = (_node$position = node.position) == null ? void 0 : _node$position.start.line;
  var metaId = getMetaId(meta) || String(line);
  var Child = components["" + metaId];
  if (metaId && typeof Child === 'function') {
    var code = data[metaId].value || '';
    var {
      title,
      boreder = 1,
      checkered = 1,
      code: codeNum = 1,
      toolbar = 1
    } = getURLParameters(meta);
    return /*#__PURE__*/_jsxs(CodeLayout, {
      bordered: !!Number(boreder),
      disableCheckered: !Number(checkered),
      children: [/*#__PURE__*/_jsx(Preview, {
        children: /*#__PURE__*/_jsx(Child, {})
      }), !!Number(toolbar) && /*#__PURE__*/_jsx(Toolbar, {
        text: code,
        visibleButton: !!Number(codeNum),
        children: title || 'Code Example'
      }), !!Number(codeNum) && /*#__PURE__*/_jsx(Code, {
        children: /*#__PURE__*/_jsx("code", _extends({}, rest))
      })]
    });
  }
  return /*#__PURE__*/_jsx("code", _extends({}, rest));
};
export default function Markdown(props) {
  var {
    source,
    components,
    data
  } = props;
  return /*#__PURE__*/_jsx(MarkdownStyle
  // style={{ paddingTop: 30 }}
  , {
    disableCopy: true,
    rehypePlugins: [rehypeIgnore],
    source: source,
    components: {
      code: rest => /*#__PURE__*/_jsx(CodePreview, _extends({}, rest, {
        components: components,
        data: data
      }))
    }
  });
}